export default __webpack_public_path__ + "static/media/us_2.4ea47059.mp3";